import './index.css';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import * as moment from 'moment';

import App from './App';
import { BrowserRouter } from 'react-router-dom';
import Utils from './utils/utils';
import registerServiceWorker from './registerServiceWorker';
import abpLocalizationConfigService from './services/abpLocalizationConfigService';
import defaultConfig from './localization/defaultConfig.json';
import loginService from './scenes/Login/services';
import configureStore from './redux/configureStore';

declare var abp: any;
Utils.setLocalization();

abpLocalizationConfigService.getLocalization().then(async function(res) {
    Utils.extend(true, abp, defaultConfig);
    if (!!abp.auth.getToken()) {
        let checktoken = await loginService.checkToken(abp.auth.getToken());
        if (checktoken) {
            abp.session.userId = checktoken.userId;
            abp.session.userFullName = [checktoken.firstName, checktoken.middleName, checktoken.lastName].join(' ');
            abp.session.securityRoleName = checktoken.securityRoleName;
            abp.auth.setRoles(checktoken.roleList, undefined);
            localStorage.setItem("PriceMultiplier", checktoken.priceMultiplier.toString());
        }
        else {
            localStorage.clear();
            sessionStorage.clear();
            abp.auth.clearToken();
        }
    }

    var loadingEl = document.getElementById('root-loading');
    if (loadingEl) {
        loadingEl.remove();
    }

    abp.localization.values = res;

    abpLocalizationConfigService.getCurrentLanguage().then(function(res) {
        abp.localization.currentLanguage = res;
        abp.localization.currentCulture = {
            name: res.name,
            displayName: res.displayName
        }
    });

    moment.locale(abp.utils.getCookieValue('Abp.Localization.CultureName'));

    const initialState = {};
    const store = configureStore(initialState);
    ReactDOM.render(
        <Provider store={store}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
          </Provider>,
        document.getElementById('root') as HTMLElement
    );

    registerServiceWorker();
});